module.exports = __webpack_public_path__ + "img/Page5.3f0385de.png";